import { ActionType, ProColumns } from '@ant-design/pro-components'
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable'
import { cloneDeep } from 'lodash'
import { observer } from 'mobx-react'
import { SearchModel } from 'pages/model'
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { WarrantyActiveReportModel } from 'services/Main/reportVisitCustomerSR'
import { reportVisitCustomerSRPresenter, reportVisitCustomerSRStore } from 'stores/root_store'

type Props = {
  dataSearch: SearchModel
  handleSearch: Dispatch<SetStateAction<SearchModel>>
}


const TableProject = ({ dataSearch, handleSearch }: Props) => {
  const { t } = useTranslation();

  const tableRef = useRef<ActionType>();

  const [dataTable, setDataTable] = useState<WarrantyActiveReportModel[]>([]);
  const [totalCount, setTotalCount] = useState<number | undefined>()

  // lấy data báo cáo =============================================================================
  const getDataReport = async (dataSearch: object) => {
    await reportVisitCustomerSRPresenter.getDataReportWarrantyActive(reportVisitCustomerSRStore, dataSearch);
    if (reportVisitCustomerSRStore.reportWarrantyActive.isSuccess) {
      const dataTemp = cloneDeep(reportVisitCustomerSRStore.reportWarrantyActive.data);
      setDataTable(dataTemp);
      setTotalCount(reportVisitCustomerSRStore.reportWarrantyActive.paging?.totalCount)
      return dataTemp;
    }
    setDataTable([]);
    return [];
  }

  // load lại request mỗi khi bấm nút tìm kiém
  useEffect(() => {
    if (dataSearch.isReload) {
      tableRef.current?.reload()
      handleSearch({ ...dataSearch, isReload: false })
    }
  }, [dataSearch.isReload])


  const [columns, setColumns] = useState<ProColumns<WarrantyActiveReportModel>[]>([
    // stt
    {
      title: t('zalo-notification.stt'),
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
    },
    //   SO
    {
      title: "SO",
      dataIndex: 'so',
      key: 'so',
      width: 100,
    },
    //   Tên sản phẩm
    {
      title: t('search-form.product-name'),
      dataIndex: 'productName',
      key: 'productName',
      width: 150,
    },
    // mã khách hàng mã dự án
    {
      title: t('project-report.customer-code'),
      dataIndex: 'profileCode',
      key: 'profileCode',
      width: 100,
    },
    //   Serial SP
    {
      title: t("warranty-active.serial-prd"),
      dataIndex: 'serial',
      key: 'serial',
      width: 120,
    },
    //   Tên bảo hành
    {
      title: t('project-report.warranty-name'),
      dataIndex: 'warrantyName',
      key: 'warrantyName',
      width: 100,
    },
    // ngày dự kiến bàn giao căn hộ
    {
      title: t("warranty-active.expected-date"),
      dataIndex: 'expectedDate',
      key: 'expectedDate',
      width: 120,
      valueType: 'dateTime',
      fieldProps: {
        format: 'DD/MM/YYYY',
      },
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // AC kích hoạt
    {
      title: t('project-report.active-ac'),
      dataIndex: 'acActivedDate',
      key: 'acActivedDate',
      width: 120,
      valueType: 'dateTime',
      fieldProps: {
        format: 'DD/MM/YYYY',
      },
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // KH kích hoạt
    {
      title: t("project-report.active-customer"),
      dataIndex: 'customerActivedDate',
      key: 'customerActivedDate',
      width: 120,
      onCell: (_, index) => ({
        className: 'text-center',
      }),
      valueType: 'dateTime',
      fieldProps: {
        format: 'DD/MM/YYYY',
      },
    },
    // Ngày kết thúc bảo hành
    {
      title: t('project-report.warranty-end-date'),
      dataIndex: 'endDateWarranty',
      key: 'endDateWarranty',
      width: 120,
      valueType: 'dateTime',
      fieldProps: {
        format: 'DD/MM/YYYY',
      },
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // Mã căn
    {
      title: t("warranty-active.apartment-code"),
      dataIndex: 'baseCode',
      key: 'baseCode',
      width: 120,
    },

  ])
  return (
    <CustomProTable
      bordered
      columns={columns}
      dataSource={dataTable}
      rowKey={'stt'}
      scroll={{ x: 1600, y: 450 }}
      actionRef={tableRef}
      request={async (params = {}, sort, filter) => {
        let data: WarrantyActiveReportModel[] = [];
        data = await getDataReport(dataSearch);

        return {
          data: data,
          success: reportVisitCustomerSRStore.reportWarrantyActive.isSuccess,
        };
      }}
      pagination={{
        ...tablePagination(dataSearch, handleSearch),
        total: totalCount,
      }}
    />
  )
}

export default observer(TableProject)